import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import "./styles/index.css";
import theme from "./theme";
import NavBar from "./components/Navbar";
import Home from "./components/Home";
import Stats from "./components/Stats";
import About from "./components/About";
import ServicesCard from "./components/ServicesCard";
import TrainingCards from "./components/TrainingCards";
import TrainingPortfolio from "./components/TrainingPortfolio";
import Products from "./components/Products";
import CaseStudies from "./components/CaseStudies";
import Roadmap from "./components/Roadmap";
import CampusCard from "./components/CampusCard";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import CertificateLookup from "./components/CertificateVerification";
import Compiler from "./components/Compiler";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <NavBar />
                <Home />
                <Stats />
                <About />
                <ServicesCard />
                <TrainingCards />
                <TrainingPortfolio />
                <Products />
                <CaseStudies />
                <Roadmap />
                <CampusCard />
                <Contact />
                <Footer />
              </>
            }
          />
          <Route path="/verify" element={<CertificateLookup />} />
          <Route path="/compiler" element={<Compiler />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
